import { IPositionTypeService } from "../../service/position/PositionTypeService";
import { IPositionType } from "../../model/position/PositionType";

export default class UpdatePositionTypeInteractor {
  private positionTypeService: IPositionTypeService;

  constructor(positionTypeService) {
    this.positionTypeService = positionTypeService;
  }

  async execute(positionType: IPositionType) {
    return this.positionTypeService.updatePositionType(positionType);
  }
}
